import InputField from "common/InputField/InputField";
import MaterialIcon from "common/MaterialIcon/MaterialIcon";
import Row from "common/Row/Row";
import { validate } from "components/IncomeElection/validationSchema";
import { useState } from "react";
import { getCityStateZip, getGender, getMaritalStatus } from "utils/Utilities";

export const personalInfo = (payload) => [
  {
    label: "name",
    value:
      payload?.firstName + " " + payload?.middleName + " " + payload?.lastName,
  },
  {
    label: "address",
    value: payload?.address1,
    hide: payload?.incomeElectionPage,
  },
  {
    label: "cityState",
    value: getCityStateZip(payload),
    hide: payload?.incomeElectionPage,
  },
  {
    label: "dob",
    value: payload?.dob,
    hide: payload?.incomeElectionPage,
  },
  {
    label: "gender",
    value: getGender(payload?.genderCode),
    hide: payload?.incomeElectionPage,
  },
  {
    label: "maritalStatus",
    value: getMaritalStatus(payload?.maritalStatusCode),
  },
  {
    label: "phone",
    value: payload?.mobile,
    editable: true,
  },
  {
    label: "email",
    value: payload?.email,
    editable: true,
  },
];

const PersonalInformation = ({
  labels,
  data,
  updatePayload = () => {},
  errors = {},
  setErrors = () => {},
  edit = true,
}) => {
  const [mobileDisabled, setMobileDisabled] = useState(true);
  const [emailDisabled, setEmailDisabled] = useState(true);
  const [touched, setTouched] = useState({});

  return (
    <div>
      {personalInfo(data).map((e, index) => {
        return !(e.editable && edit) ? (
          <Row
            key={e.label + index}
            leftValue={labels?.incomeElection[e.label]}
            rightValue={e.value}
          />
        ) : (
          <div key={e.label + index}>
            {e.label === "phone" && (
              <div className="flex-between-center border-bottom-1 py-3">
                <div className="left-value">
                  {labels?.incomeElection?.phone}
                </div>
                <div className="right-value d-flex align-items-baseline">
                  <InputField
                    type="number"
                    wrapperClassName="pe-2"
                    id="mobile"
                    ariaLabel="Mobile"
                    disabled={mobileDisabled}
                    value={data?.mobile || ""}
                    change={async (val) => {
                      updatePayload(val, "mobile");
                      setErrors({
                        ...errors,
                        mobile: await validate(val, "mobile"),
                      });
                    }}
                    touch={() => setTouched({ ...touched, mobile: true })}
                    error={errors.mobile}
                    touched={touched.mobile}
                  />
                  <MaterialIcon
                    iconName="edit_square"
                    wrapperClassName="cursor-pointer"
                    click={() => setMobileDisabled(false)}
                  />
                </div>
              </div>
            )}

            {e.label === "email" && (
              <div className="flex-between-center py-3 mb-4">
                <div className="left-value">
                  {labels?.incomeElection?.email}
                </div>
                <div className="right-value d-flex align-items-baseline">
                  <InputField
                    type="email"
                    wrapperClassName="pe-2"
                    id="email"
                    ariaLabel="email"
                    disabled={emailDisabled}
                    value={data?.email || ""}
                    change={async (val) => {
                      updatePayload(val, "email");
                      setErrors({
                        ...errors,
                        email: await validate(val, "email"),
                      });
                    }}
                    touch={() => setTouched({ ...touched, email: true })}
                    error={errors.email}
                    touched={touched.email}
                  />
                  <MaterialIcon
                    iconName="edit_square"
                    wrapperClassName="cursor-pointer"
                    click={() => setEmailDisabled(false)}
                  />
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PersonalInformation;
